import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { Visualization_UnifiedDistanceBranch_$reflection } from "../../RAWMap.Models/Common.js";
import { UnifiedBranchRangeSelectionViewModel$1_$reflection } from "../../RAWMap.Models/View/CenterlineMeasurement.js";
import { record_type, string_type, array_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Meshes_FieldDataArrayNames_$reflection } from "../Common/CommonBindings.js";

export class StentPlanningCenterlinesProps extends Record {
    constructor(lengths, viewportIdentifier, fieldDataArrayNames) {
        super();
        this.lengths = lengths;
        this.viewportIdentifier = viewportIdentifier;
        this.fieldDataArrayNames = fieldDataArrayNames;
    }
}

export function StentPlanningCenterlinesProps_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.Bindings.StentPlanningCenterlinesProps", [], StentPlanningCenterlinesProps, () => [["lengths", array_type(UnifiedBranchRangeSelectionViewModel$1_$reflection(Visualization_UnifiedDistanceBranch_$reflection()))], ["viewportIdentifier", string_type], ["fieldDataArrayNames", Meshes_FieldDataArrayNames_$reflection()]]);
}

